import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-value-added-courses',
  templateUrl: './value-added-courses.component.html',
  styleUrls: ['./value-added-courses.component.scss']
})
export class ValueAddedCoursesComponent implements OnInit {
  constructor() { }
  ngOnInit(): void { }
}
